module.exports = "mutation DeleteCampaignShare($id: ID!) {\n  deleteCampaignShare(id: $id) {\n    deleted\n  }\n}\n"